<template>
  <section :class="dense ? 'dense' : ''" :style="{width: '100%', padding: '0'}">
    <ion-label position="floating">
      {{ label }}
    </ion-label>
    <ion-input type="text" 
      v-model="textSelected"
      clear-input
      :placeholder="placeholder" 
      :disabled="computedDisabled"
      @focusout="clickedOut($event)"
      @input="input($event)" 
      @click="($event) => clickedInput($event)"/>
    
    <ion-progress-bar v-if="loading" type="indeterminate"></ion-progress-bar>
    
    <ion-card class="suggestions-card" v-if="isItemAvailable">
      <ion-item
        :key="index" 
        v-for="(item, index) in items"
      >
        <ion-button 
        expand="full"
        fill="clear"
        @click="selected(item)"
        >
          <template v-if="attributesToHighlight && attributesToHighlight.length > 0">
            <span v-html="getHighlightResult(item)"></span>
          </template>
          <template v-else>
            <div>{{ keySearcher(item) }}</div>
          </template>
        </ion-button>
      </ion-item>
      <ion-button 
        v-if="loadMore && !disabledLoadMore"
        @click="loadMoreFn()"
        expand="full"
      >
        Ver mais
      </ion-button>
    </ion-card>
  </section>
</template>

<script>
import {
  IonInput, 
  IonLabel, 
  IonProgressBar,
  IonButton, 
  IonCard, 
  IonItem
} from "@ionic/vue";

export default {
  name: "SimpleAutoComplete",
  emits:[
    'change'
  ],
  components: {
    IonInput,
    IonLabel,
    IonCard,
    IonProgressBar, 
    // IonList,
    IonButton,
    IonItem,
  },
  props: {
    attributesToHighlight: Array,
    modelValue: null,
    options: Array,
    label: String,
    placeholder: String,
    itemText: null,
    fieldsToShow: null,
    value: String,
    delay: String,
    disabled: Boolean,
    loading: Boolean,
    dense: Boolean,
    loadMore: Boolean,
    disabledObject: {
      type: Object
    }
  },
  data() {
    return {
      load: {},
      items: [],
      isItemAvailable: false,
      itemSelected: null,
      textSelected: null,
      disabledInput: false
    };
  },
  computed: {
    computedDisabled() {
      return this.disabled || this.disabledInput
    }
  },
  watch: {
    options(newValue) {
      this.items = newValue
    },
    modelValue() {
      this.itemSelected = this.modelValue
    },
    itemSelected() {
      this.textSelected = this.itemSelected ? this.keySearcher(this.itemSelected) : ''
      this.$emit('change', this.itemSelected)
    },
    textSelected(newValue) {
      if (!newValue || newValue.trim() === '') {
        this.$emit('change', null)
        this.getItems(null)
      }
    }
  },
  methods: {
    clickedOut($event) {
      // if (!$event.relatedTarget || !$event.relatedTarget.classList || !$event.relatedTarget.classList.value.includes('autocomplete-suggestion')) {
      //   this.isItemAvailable = false
      // }
    },
    clickedInput ($event) {
      if (this.isItemAvailable) {
        this.isItemAvailable = false
      } else {
        this.getItems($event, false)
        this.isItemAvailable = true
        if ($event && $event.target.nodeName === 'INPUT') {
          $event.target.select()
        } else if ($event && $event.target.nodeName === 'ION-INPUT') {
          const childInput = [...$event.target.children].find(c => c.nodeName === 'INPUT')
          if (childInput) {
            childInput.select()
          }
        }
      }
    },
    getHighlightResult(item){
      if (!this.textSelected) return this.keySearcher(item)
      return this.attributesToHighlight.map(field => 
        item[field] ? 
          item[field].replace(this.textSelected.toUpperCase(), `<em>${this.textSelected.toUpperCase()}</em>`) : 
          item[field]
      ).join(' - ')
    },
    input($event) {
      this.getItems($event)
      this.isItemAvailable = true
    },
    getItems($event, filter = true) {
      let val = null

      // set val to the value of the searchbar
      if ($event && $event.target.nodeName === 'INPUT') {
        val = $event.target.value
      } else if ($event && $event.target.nodeName === 'ION-INPUT') {
        const childInput = [...$event.target.children].find(c => c.nodeName === 'INPUT')
        if (childInput) {
          val = childInput.value
        }
      }

      if (filter) {
        if (this.timeoutSearch) {
          this.timeoutSearch(val)
        }
        else if (typeof val === 'string' && this.options) {
          if (filter) {
            this.items = this.options.filter((item) => {
              const keySearch = this.keySearcher(item)
              return keySearch.toLowerCase().indexOf(val.toLowerCase()) > -1;
            });
          } 
        } 
      } 
    },
    keySearcher(element) {
      if(Object.keys(element).length === 0) {
        return ''
      }
      else if (typeof this.itemText === "string") {
        return element[this.itemText];
      }
      else if (element) {
        return this.itemText({element})
      } else {
        return ''
      }
    },
    selected(item) {
      this.itemSelected = item
      this.isItemAvailable = false
    }
  },
  created() {
    if (this.disabledObject) {
      const { params = null, execDisable = null } = this.disabledObject
      this.disabledInput = execDisable ? execDisable(params) || false : this.disabled
    } else {
      this.disabledInput = this.disabled
    }
    if (this.modelValue) this.itemSelected = this.modelValue
  },
};
</script>
<style>
  body {
    font-family: sans-serif;
  }

  .suggestions-card {
    /* padding: 4px; */
    /* opacity: 0.5; */
    margin: 0em 1.5em .5em 1em;
    /* width: calc(100% -8px); */
    box-shadow: .1em .1em 1em .1em rgba(0, 0, 0, 0.2) !important;
  }
  .suggestions-card ion-item:not(:first-child) {
    border-top: .05em solid #929292;
  }

  .label-floating {
    color: grey!important;
  }
  
  .dark ion-input, .dark ion-select, .dark ion-textarea {
    color: white!important;
    -webkit-text-fill-color: white!important;
    opacity: 1!important; /* required on iOS */
  }

    /* ion-item.dense {
    --min-height: unset;
    font-size: 0.9em;
    padding: 3px 0;
    margin: 0;
  }  */
  section ion-label {
    --min-height: unset;
    margin: 0 8px 0 0;
  } 
  section.dense ion-label {
    --min-height: unset;
    margin: 5px 0 -5px 0!important;
    -webkit-transform: scale(0.82)!important;
    transform: scale(0.82)!important;
  } 
  section.dense ion-input {
    --min-height: unset;
  } 
  section.dense ion-input input {
    padding: 0!important;
    --min-height: unset;
  } 
</style>